export default "__VITE_ASSET__9BauMVPt__"